module.exports = __webpack_public_path__ + "img/mujer.3a5e4af3.png";